// Checkerboard behind the image, so a transparent background reads as transparent
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Column from './Column';

function CheckeredImageFrame(props) {
  const {
    children,
    action,
    wide = false,
    className,
  } = props;

  return (
    <Column
      framed
      className={classNames(
        'shrink-0 p-1',
        (wide) ? 'h-24 w-80' : 'h-36 w-36',
        className,
      )}
    >
      <div className="h-full w-full bg-checkers">
        {children}
      </div>

      {action}
    </Column>
  );
}

CheckeredImageFrame.propTypes = {
  children: PropTypes.node,
  // Shown inside the frame, over the image: the button that changes it
  action: PropTypes.node,
  wide: PropTypes.bool,
  className: PropTypes.string,
};

export default CheckeredImageFrame;
